<div class="page-title sds-page-header">
  <span class="sds-page-title">
    <span *ngIf="!isArchivedView" [translate]="'CHEMICALS'"></span>
    <span *ngIf="isArchivedView" [translate]="'SDS_ARCHIVED_TITLE'"></span>
  </span>
  <span class="page-actions sds-page-actions" *ngIf="!isArchivedView">
    <!-- Duty to keep a chemical inventory: forskrift om utførelse av arbeid § 2-1. -->
    <app-sds-legal-reference reference="chemicals"></app-sds-legal-reference>

    <!-- One QR code per business, opening the public read-only chemical list. -->
    <button
      class="btn btn-outline-primary"
      type="button"
      (click)="openListQrDialog()"
      [pTooltip]="'SDS_PUBLIC_LIST_QR_DESCRIPTION' | translate"
      tooltipPosition="bottom"
    >
      <i class="pi pi-qrcode"></i>
      <span [translate]="'SDS_PUBLIC_LIST_QR_TITLE'"></span>
    </button>

    <button class="btn btn-outline-primary" type="button" (click)="bulkImportVisible = true">
      <i class="pi pi-upload" aria-hidden="true"></i>
      <span [translate]="'SDS_BULK_IMPORT'"></span>
    </button>
    <button class="btn sds-btn-primary" type="button" (click)="addNewRecord()">
      <i class="pi pi-plus"></i>
      <span [translate]="'NEW'"></span>
    </button>
  </span>
</div>

<!-- ═══════════ PUBLIC LIST QR CODE ═══════════ -->
<sds-list-qr
  [(visible)]="listQrVisible"
  [qrCode]="listQrCode"
  [isLoading]="listQrLoading"
  [canManage]="canManageListQr"
  (createQrCodeEvent)="onCreateListQrCode($event)"
  (revokeQrCodeEvent)="onRevokeListQrCode()"
></sds-list-qr>

<!-- ═══════════ LEFT SIDEBAR for SDS PDF Viewer ═══════════ -->
<p-dialog
  [(visible)]="sidebarVisible"
  position="left"
  [style]="{ width: 'min(480px, 100vw)', height: '100dvh', maxHeight: '100dvh', margin: '0' }"
  [contentStyle]="{ flex: '1 1 auto', minHeight: '0', maxHeight: 'none' }"
  [draggable]="false"
  [resizable]="false"
  [header]="selectedSds?.ProductName || ('CHEMICALS' | translate)"
  [modal]="true"
  (onHide)="closeSidebar()"
>
  <ng-container *ngIf="selectedSds">
    <div class="sds-sidebar-body">
      <!-- Product info summary -->
      <div class="sds-info-card">
        <div class="sds-info-row">
          <span class="sds-info-label" [translate]="'SDS_SUPPLIER'"></span>
          <span class="sds-info-value">{{ selectedSds.Supplier }}</span>
        </div>
        <div class="sds-info-row" *ngIf="selectedSds.HStatementCode">
          <span class="sds-info-label" [translate]="'SDS_H_STATEMENT_CODE'"></span>
          <span class="sds-info-value">{{ selectedSds.HStatementCode }}</span>
        </div>
        <div class="sds-info-row">
          <span class="sds-info-label" [translate]="'RISK_FIGURE'"></span>
          <span
            class="badge"
            [class.sds-risk-empty]="!hasRiskFigure(selectedSds)"
            [style.background-color]="selectedSds.RiskFigure.BackColor"
          >
            {{ getRiskFigureLabel(selectedSds.RiskFigure.ValueText) || '—' }}
          </span>
        </div>
        <div class="sds-info-row sds-info-row-pictograms">
          <span class="sds-info-label" [translate]="'SDS_PICTOGRAM'"></span>
          <span class="sds-pictogram-list">
            <span
              *ngFor="let p of selectedSds.Pictograms"
              class="sds-pictogram-chip-sidebar"
              [pTooltip]="getPictogramInfo(p).ghs + ' · ' + (('SDS_PICTOGRAM_' + getPictogramInfo(p).ghs) | translate)"
              tooltipPosition="top"
            >
              <img
                [src]="getPictogramInfo(p).svg"
                [alt]="('SDS_PICTOGRAM_' + getPictogramInfo(p).ghs) | translate"
                class="ghs-pictogram-img-sidebar"
              />
              <span class="ghs-chip-label">{{ ('SDS_PICTOGRAM_' + getPictogramInfo(p).ghs) | translate }}</span>
            </span>
          </span>
        </div>
      </div>

      <!-- SDS file card -->
      <div class="sds-file-card" *ngIf="hasUploadedPdf(selectedSds)">
        <div class="sds-file-icon">
          <i class="pi pi-file-pdf"></i>
        </div>
        <div class="sds-file-details">
          <span class="sds-file-name">{{ selectedSds.SdsFileName }}</span>
          <span class="sds-file-meta">
            {{ 'UPLOADED_BY' | translate }} {{ selectedSds.EditedBy }} · {{ (selectedSds.SdsFileUploadedOn || selectedSds.CreatedOn) | date: 'dd/MM/yyyy' }}
          </span>
        </div>
      </div>

      <!-- PDF Preview / Placeholder (clickable when PDF available) -->
      <div
        class="sds-pdf-preview-card"
        [class.clickable]="hasPdf(selectedSds)"
        (click)="hasPdf(selectedSds) ? openPdfPreview(selectedSds) : null"
      >
        <i class="pi pi-file-pdf sds-pdf-preview-card-icon"></i>
        <p *ngIf="hasPdf(selectedSds)" class="sds-pdf-preview-card-text" [translate]="'SDS_CLICK_TO_PREVIEW'"></p>
        <p *ngIf="!hasPdf(selectedSds)" class="sds-pdf-preview-card-text" [translate]="'SDS_NO_PDF_UPLOADED'"></p>
        <span class="text-muted" *ngIf="hasPdf(selectedSds)">{{ selectedSds.SdsFileName }}</span>
        <button
          *ngIf="hasPdf(selectedSds)"
          class="btn btn-sm sds-preview-open-btn"
          type="button"
        >
          <i class="pi pi-external-link"></i>
          <span [translate]="'SDS_PREVIEW_PDF'"></span>
        </button>
      </div>

      <!-- Hazard statement codes -->
      <div class="sds-hazard-block">
        <h5 [translate]="'SDS_H_STATEMENT_CODE'"></h5>
        <span class="sds-h-code" *ngIf="selectedSds.HStatementCode; else noSidebarHCode">{{ selectedSds.HStatementCode }}</span>
        <ng-template #noSidebarHCode><p class="sds-detail-value-empty">—</p></ng-template>
      </div>

      <div class="sds-hazard-block">
        <h5 [translate]="'SDS_QR_CODE'"></h5>
        <div class="sds-qr-toolbar">
          <button
            class="btn btn-outline-primary btn-sm"
            type="button"
            (click)="generateQrForSelectedSds()"
            [disabled]="isGeneratingShareLink"
          >
            <i class="pi pi-qrcode"></i>
            <span>
              {{
                isGeneratingShareLink
                  ? ('SDS_GENERATING' | translate)
                  : (selectedSds.QrShareUrl ? ('SDS_REGENERATE_QR' | translate) : ('SDS_GENERATE_QR' | translate))
              }}
            </span>
          </button>
          <button
            class="btn btn-outline-primary btn-sm"
            type="button"
            (click)="openSelectedSdsShareUrl()"
            [disabled]="!selectedSds.QrShareUrl"
          >
            <i class="pi pi-external-link"></i>
            <span [translate]="'SDS_OPEN_LINK'"></span>
          </button>
          <button
            class="btn btn-outline-secondary btn-sm"
            type="button"
            (click)="copySelectedSdsShareUrl()"
            [disabled]="!selectedSds.QrShareUrl"
          >
            <i class="pi pi-copy"></i>
            <span [translate]="'SDS_COPY_LINK'"></span>
          </button>
        </div>

        <div class="sds-qr-preview-panel" *ngIf="sidebarQrCodeImageUrl">
          <div class="sds-qr-image-wrap">
            <img [src]="sidebarQrCodeImageUrl" alt="SDS QR Code" class="sds-qr-image" />
            <div class="sds-qr-logo-wrap">
              <img src="assets/images/KubaLogo.png" alt="Kuba logo" class="sds-qr-center-logo" />
            </div>
          </div>
        </div>

        <button
          class="btn btn-primary btn-sm"
          type="button"
          (click)="printQrA4ForSelectedSds()"
          [disabled]="isGeneratingShareLink"
        >
          <i class="pi pi-print"></i>
          <span [translate]="'SDS_PRINT_QR_A4'"></span>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!selectedSds">
    <div class="sds-sidebar-empty">
      <i class="pi pi-inbox" style="font-size: 3rem; color: #ccc"></i>
      <p [translate]="'NO_RECORDS_FOUND'"></p>
    </div>
  </ng-container>
</p-dialog>

<!-- ═══════════ LOADING SKELETON ═══════════ -->
<div class="sds-list-skeleton" *ngIf="loading && sdsRecords.length === 0" aria-busy="true" aria-live="polite">
  <div class="sds-skeleton-toolbar">
    <span class="sds-skeleton sds-skeleton-search"></span>
    <span class="sds-skeleton sds-skeleton-pill"></span>
  </div>
  <div class="sds-skeleton-row sds-skeleton-row--head">
    <span class="sds-skeleton sds-skeleton-cell w-name"></span>
    <span class="sds-skeleton sds-skeleton-cell w-supplier"></span>
    <span class="sds-skeleton sds-skeleton-cell w-code"></span>
    <span class="sds-skeleton sds-skeleton-cell w-risk"></span>
    <span class="sds-skeleton sds-skeleton-cell w-actions"></span>
  </div>
  <div class="sds-skeleton-row" *ngFor="let row of [1,2,3,4,5,6,7,8]">
    <span class="sds-skeleton sds-skeleton-cell w-name"></span>
    <span class="sds-skeleton sds-skeleton-cell w-supplier"></span>
    <span class="sds-skeleton sds-skeleton-cell w-code"></span>
    <span class="sds-skeleton sds-skeleton-pill w-risk"></span>
    <span class="sds-skeleton sds-skeleton-cell w-actions"></span>
  </div>
</div>

<!-- Archived view is read-only history — say so up front. -->
<div class="sds-archived-banner" *ngIf="isArchivedView">
  <i class="pi pi-box"></i>
  <span [translate]="'SDS_ARCHIVED_HELP'"></span>
</div>

<!-- ═══════════ MAIN TABLE ═══════════ -->
<div class="mb-3" *ngIf="!loading || sdsRecords.length > 0">
  <p-table
    #sdsTable
    [value]="sdsRecords"
    dataKey="Id"
    [lazy]="true"
    [loading]="loading"
    [rows]="pageSize"
    [first]="first"
    [totalRecords]="totalRecords"
    [paginator]="true"
    [pageLinks]="3"
    [rowsPerPageOptions]="[5, 10, 20]"
    paginatorDropdownAppendTo="body"
    [showCurrentPageReport]="true"
    [sortMode]="'single'"
    [sortField]="sortColumn"
    [sortOrder]="sortDirection === 'DESC' ? -1 : 1"
    (onPage)="onPage($event)"
    (onSort)="onSort($event)"
    [rowHover]="true"
    responsiveLayout="scroll"
    styleClass="sds-modern-table kuba-balanced-table"
    currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
  >
    <!-- Caption / Search -->
    <ng-template pTemplate="caption">
      <div class="sds-table-caption">
        <p-iconfield class="sds-search-field">
          <p-inputicon styleClass="pi pi-search" />
          <input
            pInputText
            type="text"
            [placeholder]="'SDS_SEARCH_PRODUCTS' | translate"
            [value]="searchTerm"
            (input)="onSearch($any($event.target)?.value)"
            class="sds-global-search"
          />
        </p-iconfield>
        <button
          *ngIf="riskFilter"
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="clearRiskFilter()"
          [attr.aria-label]="('CLEAR_FILTERS' | translate) + ': ' + getRiskFigureLabel(riskFilter)"
        >
          {{ 'RISK_FIGURE' | translate }}: {{ getRiskFigureLabel(riskFilter) }}
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
        <span class="sds-record-count" *ngIf="totalRecords">
          {{ totalRecords }} {{ 'CHEMICALS' | translate }}
        </span>
      </div>
    </ng-template>

    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ProductName" style="width: 28%">
          {{ 'SDS_PRODUCT_NAME' | translate }}
          <p-sortIcon field="ProductName"></p-sortIcon>
        </th>
        <th style="width: 18%">
          {{ 'SDS_SUPPLIER' | translate }}
        </th>
        <th style="width: 18%">{{ 'SDS_PICTOGRAM' | translate }}</th>
        <th pSortableColumn="HStatementCode" style="min-width: 200px">
          {{ 'SDS_H_STATEMENT_CODE' | translate }}
          <p-sortIcon field="HStatementCode"></p-sortIcon>
        </th>
        <th style="width: 120px">{{ 'RISK_FIGURE' | translate }}</th>
        <th class="sds-actions-column">{{ 'ACTIONS' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-record>
      <tr [class.sds-archived-row]="isArchivedView">
        <!-- Product Name (clickable → opens the preview side panel; the row's
             3-dots menu routes to the full record) -->
        <td>
          <span
            class="sds-product-link"
            (click)="openSdsSidebar(record)"
            [pTooltip]="'SDS_PREVIEW_PDF' | translate"
            tooltipPosition="top"
          >
            {{ record.ProductName }}
            <i class="pi pi-eye sds-view-icon"></i>
          </span>
          <span *ngIf="requiresCompletion(record)" class="sds-action-required"
            [pTooltip]="'SDS_ACTION_REQUIRED_HELP' | translate">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            {{ 'SDS_ACTION_REQUIRED' | translate }}
          </span>
          <!-- Archived rows are history: label why they're here and stop them
               reading as ordinary, still-in-use chemicals. -->
          <span
            *ngIf="isArchivedView"
            class="sds-archived-tag"
            [class.sds-archived-tag--deleted]="record.IsDeleted"
          >
            <i class="pi" [ngClass]="record.IsDeleted ? 'pi-trash' : 'pi-box'"></i>
            {{ (record.IsDeleted ? 'SDS_STATUS_DELETED' : 'SDS_STATUS_ARCHIVED') | translate }}
          </span>
        </td>

        <!-- Supplier -->
        <td>
          <span>{{ record.Supplier }}</span>
        </td>

        <!-- Pictograms (Official GHS SVGs) -->
        <td>
          <span class="sds-pictogram-badges">
            <img
              *ngFor="let p of record.Pictograms"
              [src]="getPictogramInfo(p).svg"
              [alt]="('SDS_PICTOGRAM_' + getPictogramInfo(p).ghs) | translate"
              [pTooltip]="getPictogramInfo(p).ghs + ' · ' + (('SDS_PICTOGRAM_' + getPictogramInfo(p).ghs) | translate)"
              tooltipPosition="top"
              class="ghs-pictogram-img"
            />
          </span>
        </td>

        <!-- H-Statement Code(s) — capped at 10 with a "+N" badge when there are
             more; the full set is visible on the detail/edit view and the SDS file. -->
        <td>
          <span class="sds-h-code-badges" *ngIf="record.HazardStatements?.length; else legacyHCodes">
            <span
              class="sds-h-code-badge"
              *ngFor="let statement of record.HazardStatements | slice:0:hCodeDisplayLimit"
              [pTooltip]="formatHazardStatement(statement)"
              tooltipPosition="top"
            >{{ statement.Code }}</span>
            <span
              *ngIf="record.HazardStatements.length > hCodeDisplayLimit"
              class="sds-h-code-more"
              [pTooltip]="'SDS_H_CODE_MORE_HINT' | translate"
              tooltipPosition="top"
            >+{{ record.HazardStatements.length - hCodeDisplayLimit }}</span>
          </span>
          <ng-template #legacyHCodes>
            <span class="sds-h-code-badges" *ngIf="splitHStatementCodes(record.HStatementCode) as codes; else noHCode">
              <ng-container *ngIf="codes.length; else noHCode">
                <span
                  class="sds-h-code-badge"
                  *ngFor="let code of codes | slice:0:hCodeDisplayLimit"
                >{{ code }}</span>
                <span
                  *ngIf="codes.length > hCodeDisplayLimit"
                  class="sds-h-code-more"
                  [pTooltip]="'SDS_H_CODE_MORE_HINT' | translate"
                  tooltipPosition="top"
                >+{{ codes.length - hCodeDisplayLimit }}</span>
              </ng-container>
            </span>
          </ng-template>
          <ng-template #noHCode><span class="sds-hazard-text">—</span></ng-template>
        </td>

        <!-- Risk Figure -->
        <td>
          <span
            class="badge"
            [class.sds-risk-empty]="!hasRiskFigure(record)"
            [style.background-color]="record.RiskFigure.BackColor"
          >
            {{ getRiskFigureLabel(record.RiskFigure.ValueText) || '—' }}
          </span>
        </td>

        <!-- Actions: quick PDF preview + the dropdown for everything else -->
        <td class="sds-actions-column">
          <span class="sds-actions-cell">
            <button
              type="button"
              class="btn btn-icon sds-actions-trigger sds-preview-trigger"
              (click)="openPdfPreview(record)"
              [disabled]="!hasPdf(record)"
              [pTooltip]="'SDS_PREVIEW_PDF' | translate"
              tooltipPosition="top"
              [attr.aria-label]="'SDS_PREVIEW_PDF' | translate"
            >
              <i class="pi pi-eye"></i>
            </button>
            <button
              type="button"
              class="btn btn-icon sds-actions-trigger"
              (click)="openActionsMenu($event, record)"
              [pTooltip]="'ACTIONS' | translate"
              tooltipPosition="left"
              [attr.aria-label]="'ACTIONS' | translate"
            >
              <i class="pi pi-ellipsis-v"></i>
            </button>
          </span>
        </td>
      </tr>
    </ng-template>

    <!-- Empty message -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">
          {{ 'NO_RECORDS_FOUND' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Shared Actions dropdown (one instance; model set per row on open) -->
  <p-menu
    #rowActionsMenu
    [popup]="true"
    [model]="actionMenuItems"
    appendTo="body"
    styleClass="sds-actions-menu"
  ></p-menu>
</div>

<!-- ═══════════ PDF PREVIEW DIALOG ═══════════ -->
<p-dialog
  [header]="'SDS_PDF_PREVIEW_TITLE' | translate"
  [(visible)]="pdfPreviewVisible"
  [style]="{ width: '90vw', height: '90vh' }"
  [baseZIndex]="10000"
  [maximizable]="true"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  (onHide)="closePdfPreview()"
  styleClass="sds-pdf-dialog"
>
  <div class="sds-pdf-dialog-toolbar">
    <div class="sds-pdf-dialog-hint">
      <i class="pi pi-info-circle"></i>
      <span>{{ pdfPreviewFileName }}</span>
    </div>
    <div class="sds-pdf-dialog-actions">
      <button
        *ngIf="pdfPreviewRecord && hasUploadedPdf(pdfPreviewRecord)"
        class="btn btn-outline-primary sds-pdf-download-btn"
        type="button"
        (click)="downloadPdf()"
        [pTooltip]="'SDS_DOWNLOAD_PDF' | translate"
        tooltipPosition="left"
      >
        <i class="pi pi-download"></i>
        <span [translate]="'SDS_DOWNLOAD_PDF'"></span>
      </button>
    </div>
  </div>

  <div class="sds-pdf-no-file" *ngIf="pdfPreviewLoading">
    <i class="pi pi-spin pi-spinner"></i>
    <span [translate]="'PROCESSING'"></span>
  </div>
  <div class="sds-pdf-iframe-wrapper" *ngIf="!pdfPreviewLoading && pdfPreviewUrl">
    <iframe
      [src]="pdfPreviewUrl"
      class="sds-pdf-iframe"
      frameborder="0"
    ></iframe>
  </div>
  <div class="sds-pdf-no-file" *ngIf="!pdfPreviewLoading && !pdfPreviewUrl">
    <i class="pi pi-exclamation-triangle"></i>
    <span [translate]="'SDS_PDF_NOT_AVAILABLE'"></span>
  </div>
</p-dialog>

<!-- ═══════════ DELETE CONFIRMATION DIALOG ═══════════ -->
<p-dialog
  [header]="'SDS_DELETE_RECORD' | translate"
  [(visible)]="confirmDeleteVisible"
  [style]="{ width: '420px' }"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  (onHide)="cancelDelete()"
>
  <div class="sds-confirm-delete-body">
    <i class="pi pi-exclamation-triangle sds-confirm-icon"></i>
    <p *ngIf="recordToDelete">
      {{ 'SDS_DELETE_CONFIRM_MSG' | translate: { name: recordToDelete.ProductName } }}
    </p>
  </div>
  <ng-template pTemplate="footer">
    <button class="btn btn-outline-secondary" (click)="cancelDelete()">
      <span [translate]="'CANCEL'"></span>
    </button>
    <button class="btn btn-danger" (click)="executeDelete()">
      <i class="pi pi-trash"></i>
      <span [translate]="'DELETE'"></span>
    </button>
  </ng-template>
</p-dialog>

<!-- ═══════════ ARCHIVE CONFIRMATION DIALOG ═══════════ -->
<p-dialog
  [header]="'SDS_ARCHIVE_RECORD' | translate"
  [(visible)]="confirmArchiveVisible"
  [style]="{ width: '420px' }"
  [resizable]="false"
  [draggable]="false"
  [modal]="true"
  (onHide)="cancelArchive()"
>
  <div class="sds-confirm-delete-body">
    <i class="pi pi-inbox sds-confirm-icon sds-confirm-icon-archive"></i>
    <div>
      <p *ngIf="recordToArchive">
        {{ 'SDS_ARCHIVE_CONFIRM_MSG' | translate: { name: recordToArchive.ProductName } }}
      </p>
      <p class="sds-confirm-delete-hint" [translate]="'SDS_ARCHIVE_HINT'"></p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button class="btn btn-outline-secondary" (click)="cancelArchive()">
      <span [translate]="'CANCEL'"></span>
    </button>
    <button class="btn btn-primary" (click)="executeArchive()">
      <i class="pi pi-inbox"></i>
      <span [translate]="'SDS_ARCHIVE_RECORD'"></span>
    </button>
  </ng-template>
</p-dialog>


<app-sds-bulk-import [businessId]="businessId" [(visible)]="bulkImportVisible"
  (imported)="onBulkImported()"></app-sds-bulk-import>
